import { Plane } from 'lucide-react'

interface FreeShippingProgressProps {
  subtotal: number
  threshold: number
  message: string
}

export function FreeShippingProgress({ subtotal, threshold, message }: FreeShippingProgressProps) {
  const remainingForFreeShipping = Math.max(0, threshold - subtotal)
  const progressPercentage = Math.min(100, (subtotal / threshold) * 100)

  return (
    <div className="mt-4 h-fit w-full rounded-md bg-tertiary-200 p-3 sm:mt-6 sm:p-2">
      <div className="mb-2 mt-1 h-2 overflow-hidden rounded-full bg-secondary-100">
        <div className="h-2 bg-primary-500 transition-all duration-300" style={{ width: `${progressPercentage}%` }} />
      </div>
      <p className="flex items-start gap-2 break-words text-xs text-gray-700 sm:items-center sm:gap-1 sm:text-sm">
        <Plane className="mt-0.5 h-3 w-3 flex-shrink-0 text-gray-600 sm:mt-0 sm:h-4 sm:w-4" />
        <span className="text-xs leading-tight">
          {remainingForFreeShipping <= 0
            ? 'Custo de importação grátis! Parabéns!'
            : message.replace('{amount}', `R$ ${remainingForFreeShipping.toFixed(2)}`)}
        </span>
      </p>
    </div>
  )
}
